import { BaseError } from "../classes/BaseError";
import type { ErrorContext } from "../types/index";
import { FRONTEND_ERROR_CODES } from "../constants/errorCodes";

export interface FrontEndErrorOptions {
  message: string;
  context?: Partial<ErrorContext>;
  code?: string;
  cause?: Error;
}

/**
 * Error thrown when a resource is not found
 */
export class FrontEndError extends BaseError {
  constructor(options: FrontEndErrorOptions) {
    super({
      message: options.message,
      category: "frontend",
      severity: "low",
      code: options.code ?? FRONTEND_ERROR_CODES.FRONTEND_ERROR,
      context: options.context,
      cause: options.cause,
      userVisible: true,
      reportable: false,
    });
  }
}
